import {
  dateTimeFormat,
  unixToDuration,
  clipValueToInewsUnixRange,
  dateToUnix,
  durationToUnix,
} from './date';

const formatExtraFieldsForDisplay = (storyExtraFields, extraFieldsInfo) => {
  let formattedExtraFields = [];
  storyExtraFields.forEach(currentExtraField => {
    formattedExtraFields.push({ ...currentExtraField });

    if (
      currentExtraField.field === 'create-date' ||
      currentExtraField.field === 'modify-date'
    ) {
      formattedExtraFields[
        formattedExtraFields.length - 1
      ].value = dateTimeFormat(currentExtraField.value, false);
    }

    const fieldInfo = extraFieldsInfo.find(
      item => item.field === currentExtraField.field,
    );
    if (!fieldInfo || !currentExtraField.value) {
      return;
    }
    switch (fieldInfo.type) {
      case 'datecell':
        formattedExtraFields[
          formattedExtraFields.length - 1
        ].value = dateTimeFormat(currentExtraField.value, false);
        break;
      case 'durationcell':
        formattedExtraFields[
          formattedExtraFields.length - 1
        ].value = unixToDuration(currentExtraField.value);
        break;
    }
  });
  return formattedExtraFields;
};

const formatExtraFieldsForStorage = (storyExtraFields, extraFieldsInfo) => {
  let formattedExtraFields = {};
  for (const [key, value] of Object.entries(storyExtraFields)) {
    if (!value) {
      formattedExtraFields[key] = '';
    } else {
      formattedExtraFields[key] = value;
      const fieldInfo = extraFieldsInfo.find(item => item.field === key);
      switch (fieldInfo && fieldInfo.type) {
        case 'datecell':
          formattedExtraFields[key] = clipValueToInewsUnixRange(
            dateToUnix(value, 'YYYY-MM-DD - HH:mm:ss'),
          );
          break;
        case 'durationcell':
          formattedExtraFields[key] = durationToUnix(value);
          break;
      }
    }
  }
  return formattedExtraFields;
};

const formatTableExtraFields = (tableNews, extraFieldsInfo) => {
  const formattedTable = [];
  tableNews.forEach(function(story, index) {
    formattedTable.push({ ...story });
    const formattedExtraFields = formatExtraFieldsForDisplay(
      story.data,
      extraFieldsInfo,
    );
    formattedTable[index].data = formattedExtraFields;
  });
  return formattedTable;
};

export {
  formatExtraFieldsForDisplay,
  formatExtraFieldsForStorage,
  formatTableExtraFields,
};
